export const WebhooksRoute = {
  WEBHOOKS: 'webhooks',
};

export const WebhooksPathName = {
  WEBHOOKS: 'webhooks',
  NEW: 'new',
  EDIT: 'edit',
  HISTORY: 'history',
};

export const WebhookEventRuleOperators = {
  IN: 'IN',
  NOT_IN: 'NOT_IN',
};

export const WebhookEventValues = [
  { key: 'CREATE_USER', value: i18n.$t('Create User') },
  { key: 'UPDATE_USER', value: i18n.$t('Update User') },
  { key: 'DATA_EXPORT', value: i18n.$t('Data Exporter Completion') },
];

export const PredefinedFilterName = 'active';
